<template>
    <div class="btns-box">
        <p class="btn"
            v-for="(item, index) in form"
           :key="index"
           @click="handlerClick(item)"
        >
            <span class="name" v-html="item.value"></span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "btns-box",
        props: {
            form: Array
        },
        methods: {
            handlerClick(item){
                this.$emit('onSelect', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.btns-box{
    position: absolute;
    top: 66px;
    right: -110px;
    width: 96px;
    padding: 8px 8px 2px;
    background: #36383F;
    border-radius: 4px;

    .btn{
        display: flex;
        flex-direction: row;
        justify-content: center;
        line-height: 29px;
        background: #494B54;
        border-radius: 4px;
        margin-bottom: 6px;
        padding: 0px 8px;
        transition: background .2s linear;

        &:hover{
            background-color: #FF7838;
            cursor: pointer;
        }
        &:active{
            opacity: .9;
        }

        .name{
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
</style>
